/*Seznam api klicev*/

/*----------------------------- |   IMENIK  | ------------------------------------*/
export const imenikSifrant = `${process.env.REACT_APP_APIDOMAIN_IMENIK}imenik/seznam`;

export const izbranaOsebaPodrobnosti = `${process.env.REACT_APP_APIDOMAIN_IMENIK}imenik/oseba`;

/* --------------------------|     DASHBOARD      |-------------------------------*/
/* GET --> Dashboard overview data */
export const dashboardOverview = `${process.env.REACT_APP_APIDOMAIN}dashboard/overview`;

/* GET --> Projects by role */
export const dashboardProjektiPoVlogi = `${process.env.REACT_APP_APIDOMAIN}dashboard/projekti-po-vlogi`;

/* GET --> Projects by member */
export const dashboardProjektiPoClanici = `${process.env.REACT_APP_APIDOMAIN}dashboard/projekti-po-clanici`;

/* GET --> Projects by program */
export const dashboardProjektiPoProgramu = `${process.env.REACT_APP_APIDOMAIN}dashboard/projekti-po-programu`;

/* GET --> Projects by year */
export const dashboardProjektiPoLetu = `${process.env.REACT_APP_APIDOMAIN}dashboard/projekti-po-letu`;

/* GET --> Projects by financing type */
export const dashboardProjektiPoFinanciranju = `${process.env.REACT_APP_APIDOMAIN}dashboard/projekti-po-financiranju`;

/* GET --> Recent projects */
export const dashboardZadnjiProjekti = `${process.env.REACT_APP_APIDOMAIN}dashboard/zadnji-projekti`;

/* GET --> Potekli projekti */
export const dashboardPotekliProjekti = `${process.env.REACT_APP_APIDOMAIN}dashboard/potekli-projekti`;

/* --------------------------|       PROJEKTI      |-------------------------------*/
/* GET --> Vloga na projektu */
export const vlogaProjekta = `${process.env.REACT_APP_APIDOMAIN}sifrant/vloga`;

/* GET --> Podatki - podrobnosti za projekt */
export const podrobnostiPodatkiZaProjekt = `${process.env.REACT_APP_APIDOMAIN}projekti`;

/*GET --> Izvoz projektov */
export const izvozProjektov = `${process.env.REACT_APP_APIDOMAIN}projekti/izvoz`;

/*GET --> Izvoz partnerjev s projekti */
export const izvozPartnerjev = `${process.env.REACT_APP_APIDOMAIN}projekti/izvozPartnerji`;

/*POST --> Izvoz občanske znanosti */
export const izvozObcanskaZnanost = `${process.env.REACT_APP_APIDOMAIN}projekti/izvoz/obcanska-znanost`;

/*POST --> Izvoz občanske znanosti */
export const izvozObcanskaZnanostSkrbnik = `${process.env.REACT_APP_APIDOMAIN}projekti/izvoz/obcanska-znanost-skrbnik`;

/*POST --> Izvoz občanske znanosti */
export const izvozObcanskaZnanostVsi = `${process.env.REACT_APP_APIDOMAIN}projekti/izvoz/obcanska-znanost-vsi`;

/*POST --> Izvoz občanske znanosti */
export const izvozObcanskaZnanostClaniceZdruzeno = `${process.env.REACT_APP_APIDOMAIN}projekti/izvoz/obcanska-znanost-clanice-zdruzeno`;

/*POST --> Izvoz občanske znanosti */
export const izvozObcanskaZnanostClanice = `${process.env.REACT_APP_APIDOMAIN}projekti/izvoz/obcanska-znanost-clanice`;

/*POST --> Izvoz občanske znanosti sodelujoče osebe */
export const izvozObcanskaZnanostSodelujoceOsebe = `${process.env.REACT_APP_APIDOMAIN}projekti/izvoz/obcanska-znanost-sodelujoce-osebe`;

/* POST --> Vnos osnovnih podatkov za projekt oz. kreiranje projekta */
export const vnosNovegaProjekta = `${process.env.REACT_APP_APIDOMAIN}projekti`;

/* --------------------------| PROJEKTNI PARTNERJI |-------------------------------*/

/* GET --> Podatki za specifičnega partnerja */
export const podatkiZaPartnerja = `${process.env.REACT_APP_APIDOMAIN}partnerji`;

/* POST --> Vnos partnerja */
export const vnosNovegaPartnerja = `${process.env.REACT_APP_APIDOMAIN}partnerji`;

/* PUT --> Vnos partnerja */
export const urejanjePartnerja = `${process.env.REACT_APP_APIDOMAIN}partnerji`;

/* --------------------------| ORGANIZACIJSKE ENOTE |-------------------------------*/
/* GET --> Podatki za specifičnega partnerja */
export const podatkiZaEnoto = `${process.env.REACT_APP_APIDOMAIN}partnerji`;

/* POST --> Vnos partnerja */
export const vnosNoveOrgEnote = `${process.env.REACT_APP_APIDOMAIN}partnerji`;

/* PUT --> Vnos partnerja */
export const urejanjeNoveOrgEnote = `${process.env.REACT_APP_APIDOMAIN}partnerji`;

/* DELETE --> Vnos partnerja */
export const brisanjeNoveOrgEnote = `${process.env.REACT_APP_APIDOMAIN}partnerji`;

/* ---------------------------------| PROGRAMI |-----------------------------------------*/

/* GET  --> Podatki za vse programe, ki so na prvem nivoju (velja za: K1) */
export const prviNivoProgramiAPI = `${process.env.REACT_APP_APIDOMAIN}programi/nivo1`;

/*GET --> Podatki za vse programe, ki so na prvem nivoju  aktivni */
export const prviNivoProgramiAktivni = `${process.env.REACT_APP_APIDOMAIN}programi/nivo1/aktivni`;

/* GET --> Struktura oz. seznam vse otrok  oz. podkategorij nekega programa (velja za: K1) glede na njegov ID */
export const programStrukturaAPI = `${process.env.REACT_APP_APIDOMAIN}programi/struktura`;

/* GET --> Iskanje po celotni strukturi programov od nivo1 dalje */
export const iskanjeProgramStrukturaNivo1 = `${process.env.REACT_APP_APIDOMAIN}programi/nivo1/struktura`;

/* GET --> Podatki za specifičen program glede na ID (velja za: K1, K2, K3, K4) */
export const podatkiZaProgram = `${process.env.REACT_APP_APIDOMAIN}programi`;

/*GET --> pot od programa/podprogram pri dodajanju in spreminjanju apija */
export const potDoPrograma = `${process.env.REACT_APP_APIDOMAIN}programi/pot`;

/*GET --> seznam podprogramov glede na id programa (K1)*/
export const seznamPodprogramov = `${process.env.REACT_APP_APIDOMAIN}programi/struktura/flat`;

/*GET --> seznam vseh programov/podprogramov */
export const seznamVsehProgramov = `${process.env.REACT_APP_APIDOMAIN}programi/sifrant`;

/*GET --> pridobivanje root programa za specifični podprogram na podlagi id */
export const rootProgram = `${process.env.REACT_APP_APIDOMAIN}programi`;

/* POST --> Vnos novega programa (vezlja za: K1, K2, K3, K4) */
export const vnosNovegaPrograma = `${process.env.REACT_APP_APIDOMAIN}programi`;

/* PUT --> Urejanje programa (velja za; K1, K2, K3, K4) */
export const urejanjePrograma = `${process.env.REACT_APP_APIDOMAIN}programi`;

/* PUT --> Nastavi posamezen program ali  podprogram aktiven ali neaktiven) */
export const spremeniStatusProgram = `${process.env.REACT_APP_APIDOMAIN}programi/aktiven`;

/*-------------------------------------| RAZPISI |-------------------------------------*/

/* GET --> Podatki za specifičen razpis glede na ID */
export const podatkiZaRazpis = `${process.env.REACT_APP_APIDOMAIN}razpisi`;

/* GET --> Podatki za finančne vire za posamezen razpis glede na ID */
export const financniViriRazpisa = `${process.env.REACT_APP_APIDOMAIN}razpisi`;

/*GET --> Seznam razpisov z pripadajočimi programi/podprogrami */
export const sifrantRazpisov = `${process.env.REACT_APP_APIDOMAIN}razpisi/sifrant`;

/* GET --> Seznam akutlanih izpostavljenih izpisov */
export const izpostavljeniAktualniRazpisi = `${process.env.REACT_APP_APIDOMAIN}razpisi/aktualni/izpostavljeni`;

/* GET --> Seznam aktualnih razpisov */
export const seznamAktualnihRazpisov = `${process.env.REACT_APP_APIDOMAIN}razpisi/aktualni`;

/* GET -->  aktualnih razpiso (zadnja verzija seznama) */
export const aktualniSeznamVerzija = `${process.env.REACT_APP_APIDOMAIN}razpisi/aktualni/verzija`;

/* GET --> Seznam projektov za posamezen razpis glede na ID */
export const projektiZaRazpis = `${process.env.REACT_APP_APIDOMAIN}razpisi`;

/* POST --> Vnos novega razpisa */
export const vnosNovegaRazpisa = `${process.env.REACT_APP_APIDOMAIN}razpisi`;

/* POST --> Vnos novega finančnega vira na razpis */
export const vnosNovegaFinancnegaVira = `${process.env.REACT_APP_APIDOMAIN}razpisi`;

/* POST --> Vnos aktualnih razpisov N1  */
export const vnosAktualnihRazpisov = `${process.env.REACT_APP_APIDOMAIN}razpisi/aktualni/vnos1`;

/* POST --> Vnos aktualnih razpisov podkategorije N2  */
export const vnosAktualnihRazpisovPodkategorije = `${process.env.REACT_APP_APIDOMAIN}razpisi/aktualni/vnos/podkategorija`;

/* POST --> Vnost aktualnih razpisov N3 */
export const vnosAktualnihRazpisovTretjaKategorija = `${process.env.REACT_APP_APIDOMAIN}razpisi/aktualni/vnos/razpis`;

/* POST --> Vnos nove verzije aktualne verzije razpisa (za html predlogo prikaz) */
export const vnosNoveVerzijeAktualnegaRazpisa = `${process.env.REACT_APP_APIDOMAIN}razpisi/aktualni/verzija`;

/* PUT --> Urejanje obstoječega razpisa */
export const urejanjeRazpisa = `${process.env.REACT_APP_APIDOMAIN}razpisi`;

/* PUT --> Urejanje obstoječega finančnega vira */
export const urejanjeFinancnegaVira = `${process.env.REACT_APP_APIDOMAIN}razpisi`;

/* PUT --> Urejanje aktualenga razpisa (kategorija) */
export const urejanjeAktualnegaRazpisaKategorija = `${process.env.REACT_APP_APIDOMAIN}razpisi/aktualni/kategorije`;

/* PUT --> Urejanje aktualenga razpisa (podkategorija) */
export const urejanjeAktualnegaRazpisaPodkategorija = `${process.env.REACT_APP_APIDOMAIN}razpisi/aktualni/podkategorije`;

/* PUT --> Urejanje aktualenga razpisa (razpis) */
export const urejanjeAktualnegaRazpisaRazpisa = `${process.env.REACT_APP_APIDOMAIN}razpisi/aktualni/razpisi`;

/* PUT --> Urejanje aktualenga razpisa spreminjanje vrstnega reda kategorije */
export const vrstniRedKategorije = `${process.env.REACT_APP_APIDOMAIN}razpisi/aktualni/kategorije/vrstni_red`;

/* PUT --> Urejanje aktualenga razpisa spreminjanje vrstnega reda podkategorij */
export const vrstniRedPodkategorije = `${process.env.REACT_APP_APIDOMAIN}razpisi/aktualni/podkategorije/vrstni_red`;

/*DELETE --> Brisanje razpisaGlede na njegov ID */
export const izbrisFinancnegaVira = `${process.env.REACT_APP_APIDOMAIN}razpisi`;

/* DELETE --> Brisanje aktualnih razpisov kategorije */
export const brisanjeAktualnihRazpisov = `${process.env.REACT_APP_APIDOMAIN}razpisi/aktualni/kategorije`;

/* DELETE --> Brisanje aktualnih razpisov podkategorije */
export const brisanjeAktualnihRazpisovPodkategorije = `${process.env.REACT_APP_APIDOMAIN}razpisi/aktualni/podkategorije`;

/* DELETE --> Brisanje aktualni razpisov (razpisi na 1 ali 3 nivoju) */
export const brisanjeAktualnihRazpisovPrviTretjiNivo = `${process.env.REACT_APP_APIDOMAIN}razpisi/aktualni`;

/*-------------------------------------| AVTORIZACIJE |-------------------------------------*/

/* GET --> seznam userjev z avtorizacijami */
export const seznamUserjevAvtorizacije = `${process.env.REACT_APP_APIDOMAIN}avtorizacije`;

/* GET --> seznam fakultetnih userjev z avtorizacijami */
export const seznamFakultetnihUserjevAvtorizacije = `${process.env.REACT_APP_APIDOMAIN}avtorizacije/clanice`;

/* GET --> pridobi podatke avtorizacij uporabnika na podlagi id */
export const userAvtorizacije = `${process.env.REACT_APP_APIDOMAIN}avtorizacije/id`;

/*GET --> pridobi podatke avtorizacij uporabnika na podlagi upn */
export const userAvtorizacijeUpn = `${process.env.REACT_APP_APIDOMAIN}avtorizacije/upn`;

/* POST --> Vnos nove avtorizacije*/
export const vnosAvtorizacije = `${process.env.REACT_APP_APIDOMAIN}avtorizacije`;

/*PUT --> Urejanje avtorizacij uporabnik */
export const urejanjeAvtorizacije = `${process.env.REACT_APP_APIDOMAIN}avtorizacije`;

/*DELETE --> Brisanje uporabnika glede na njegov Id*/
export const brisanjeUporabnikovihAvtorizacij = `${process.env.REACT_APP_APIDOMAIN}avtorizacije`;

/*-------------------------------------| ZGODOVINA SPREMEB |-------------------------------------*/

/* GET  --> Podatki za revizijskeSledi  */
export const seznamRevizija = `${process.env.REACT_APP_APIDOMAIN}revizija`;

/*-------------------------------------| ŠIFRANT |-------------------------------------*/

/*GET --> Šifranti ARRS */
export const sifrantARRS = `${process.env.REACT_APP_APIDOMAIN}sifrant/arrs`;

/*GET --> Šifranti Cerif */
export const sifrantCerif = `${process.env.REACT_APP_APIDOMAIN}sifrant/cerif`;

/*GET --> Šifranti Klasius */
export const sifrantKlasius = `${process.env.REACT_APP_APIDOMAIN}sifrant/klasius`;

/* GET --> Seznam vseh članic */
export const claniceUM = `${process.env.REACT_APP_APIDOMAIN}sifrant/clanice`;

/* GET --> Seznam držav */
export const drzave = `${process.env.REACT_APP_APIDOMAIN}sifrant/drzave`;

/* GET -->  Financiranje kategorije */
export const financiranjeKategorije = `${process.env.REACT_APP_APIDOMAIN}sifrant/financiranje_kategorije`;

/*GET --> Viri financiranja */
export const financiranjeViri = `${process.env.REACT_APP_APIDOMAIN}sifrant/viri_financiranja`;

/*GET --> kontaktiUM */
export const kontaktiUM = `${process.env.REACT_APP_APIDOMAIN}sifrant/kontaktiUM`;

/*GET --> claniceV2 */
export const claniceV2 = `${process.env.REACT_APP_APIDOMAIN}sifrant/claniceV2`;

/*PUT --> claniceV2 */
export const putClaniceV2 = `${process.env.REACT_APP_APIDOMAIN}projekti/claniceV2`;

/*GET --> koristniLinki */
export const koristniLinki = `${process.env.REACT_APP_APIDOMAIN}sifrant/koristni-linki`;

/*-------------------------------------| DEMINIMIS POMOČ |-------------------------------------*/

/* GET --> Iskanje članic za prejemnik državne pomoči */
export const projektnaPomocClaniceSearch = `${process.env.REACT_APP_APIDOMAIN}deminimis-pomoc/clanice`;

/* GET --> Iskanje projektov */
export const projektnaPomocProjektiSearch = `${process.env.REACT_APP_APIDOMAIN}deminimis-pomoc/projekti`;

/* GET --> Iskanje partnerjev za dajalec */
export const projektnaPomocPartnerjiSearch = `${process.env.REACT_APP_APIDOMAIN}deminimis-pomoc/partnerji`;

/* POST --> Vnos projektne pomoči */
export const projektnaPomoc = `${process.env.REACT_APP_APIDOMAIN}deminimis-pomoc`;

/* GET --> Seznam odobrene pomoči po datumu */
export const projektnaPomocPoDatumu = `${process.env.REACT_APP_APIDOMAIN}deminimis-pomoc/by-date`;

/* GET --> Seznam vseh de minimis vnosov */
export const projektnaPomocSeznam = `${process.env.REACT_APP_APIDOMAIN}deminimis-pomoc/seznam`;

/*-------------------------------------| VSTOPNA STRAN |-------------------------------------*/
export const obvestilaAdmin = `${process.env.REACT_APP_APIDOMAIN}admin/obvestila`;
